import React, { useEffect } from "react"
import axios from "axios"
import { Ridecell, Carsharing } from "@ridecell/web-sdk"
import useGlobalContext from "./useGlobalContext"
import jwt_decode from "jwt-decode"

const useInitializeSDK = () => {
  const {
    state: { sdkInitialized, config },
    setSdkInitialized,
    setTenantSettings,
    setSDKError,
    setTenantId,
    setConfig,
  } = useGlobalContext()

  useEffect(() => {
    const fetchConfig = async () => {
      const { data: config } = await axios.get("config.json")
      setConfig(config)
    }
    if (!sdkInitialized) {
      fetchConfig()
    }
  }, [])

  // Initialize SDK
  useEffect(() => {
    async function loadAndSetConfig() {
      if (!config) {
        return
      }
      const authToken = jwt_decode(config.auth_token)
      setTenantId(authToken.tenant_id)
      Ridecell.init(config)
        .then((tenantSettings) => {
          setTenantSettings(tenantSettings)
          setSdkInitialized(true)
          Carsharing.init()
        })
        .catch((error) => {
          setSdkInitialized(false)
          setSDKError(true)
        })
    }

    async function init() {
      await loadAndSetConfig()
    }
    init()
  }, [config])

  const initSDK = () => setSdkInitialized(false)

  return { initSDK }
}

export default useInitializeSDK
